<template>
  <div class="">
    <Loading v-if="isInfoLoading"/>
    <v-card v-else class="mx-3 my-5 pa-1">

      <Results :results="getResults" />

      <v-toolbar color="bbe-blue" dark >

        <v-toolbar-title>LANGUAGES</v-toolbar-title>
        <v-spacer></v-spacer>


        <v-menu offset-y offset-yorigin="center center">
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="editItem">
              <v-list-item-title>NEW LANGUAGE</v-list-item-title>

            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>

      <v-card class="mx-1 my-1 pa-3">
        <v-data-table
        :headers="headers"
        :items="languages"
        sort-by="name"
        :search="search"
        class="pa-1 ma-1">

          <template v-slot:top>
            <v-dialog v-model="getLanguageDialogEdit" persistent>
              <Errors :errors="getErrors" />
              <v-card>
                <v-card-title class="headline justify-center bbe-blue white--text" >
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-main class="pa-1">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field v-model="editedItem.name" label="Name">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field v-model="editedItem.link" label="Link">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-main>
                </v-card-text>

                <v-card-actions class="d-flex justify-center">
                  <v-btn class="bbe-blue" dark text @click="save">
                    Save
                  </v-btn>
                  <v-btn class="bbe-orange" dark text @click="close">
                    Cancel
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- The following dialog is for delete item -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline justify-center bbe-blue white--text" >
                  Language - Delete
                </v-card-title>
                <div class="text--primary text-center ma-2">
                  Are you sure you want to delete this item?
                </div>
                <v-card-actions class="justify-center">

                  <v-btn class="bbe-orange" dark text @click="deleteItemConfirm">
                    DELETE
                  </v-btn>
                  <v-btn class="bbe-blue" dark text @click="closeDelete">
                    CANCEL
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogShow" max-width="800px">
              <v-card>
                <v-card-title class="headline justify-center bbe-blue white--text" >
                  LANGUAGE
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="2" class="font-weight-bold">
                        Id
                      </v-col>

                      <v-col cols="12" sm="4">
                        {{ editedItem.id }}
                      </v-col>
                      <v-col cols="12" sm="2" class="font-weight-bold">
                        Name
                      </v-col>

                      <v-col cols="12" sm="4">
                        {{ editedItem.name }}
                      </v-col>

                      <v-col cols="12" sm="2" class="font-weight-bold">
                        Link
                      </v-col>

                      <v-col cols="12" sm="4">
                        {{ editedItem.link }}
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>

          </template>
          <!-- The following are the icons for the CRUD actions -->
          <template v-slot:item.actions="{ item }" class="justify-around">
            <v-icon medium class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon medium @click="showItem(item)">
              mdi-eye
            </v-icon>
            <v-icon medium @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-card>
  </div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import Errors from "@/components/Errors";
import Results from "@/components/Results";
import Loading from "@/components/Loading";

export default {
  created() {
    this.initializeLanguage();
  },
  components: {
    Errors,
    Loading,
    Results
  },
  computed: {
    ...mapGetters([
      "getErrors",
      "getResults",
      "isInfoLoading",
      "getLanguageDialogEdit"
    ]),
    formTitle() {
      return this.editedItem === -1 ? "New Language" : "Edit Language";
    }
  },
  data(){
    return {
      defaultItem: {
        name: ""
      },
      dialogEdit: false,
      dialogDelete: false,
      dialogShow: false,
      editedItem: {
        name: " ",
        link: " "
      },
      editedIndex: -1,
      headers: [
        { text: "Id", value: "id" },
        { text: "Name", value: "name" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      search: ""
    }
  },
  methods: {
    ...mapActions([
      "createLanguage",
      "deleteLanguage",
      "initializeLanguage",
      "updateLanguage",
      "setLanguageDialogEditStatus"
    ]),
    close() {
      this.$store.commit("INITIALIZE_ERRORS")
      this.$store.commit("INITIALIZE_RESULTS")
      this.setLanguageDialogEditStatus();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.$store.commit("INITIALIZE_ERRORS")
      this.$store.commit("INITIALIZE_RESULTS")
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    deleteItem(item) {
      this.editedIndex = this.languages.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      // this.students.splice(this.editedIndex, 1);
      this.deleteLanguage(this.editedItem);
      this.closeDelete();
    },
    editItem(item) {
      this.$store.commit("INITIALIZE_ERRORS")
      this.$store.commit("INITIALIZE_RESULTS")
      this.editedIndex = this.languages.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.setLanguageDialogEditStatus();
    },
    save() {
      // if index is different to -1 means the record was modified
      if (this.editedIndex > -1) {
        this.updateLanguage(this.editedItem);
      } else {
        // this means is a new record
        this.createLanguage(this.editedItem);
      }
    },
    showItem(item) {
      this.showedIndex = this.languages.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogShow = true;
    }
  },
  name: "Language",
  props: {
    languages: {
      type: Array,
      required: true
    }
  }
}

</script>
